<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import type {
  AppIconColor,
  AppIconProps,
} from '../../models/elements/Icon.model'

const props = withDefaults(defineProps<AppIconProps>(), {
  size: 'sm',
  color: 'basics-icon',
})

const attrs = useAttrs()

const iconSize = computed(() => {
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  }
  return sizes[props.size] || sizes.md
})

const iconColor = computed(() => {
  const predefinedColors: AppIconColor[] = [
    'white',
    'black',
    'primary',
    'secondary',
    'quaternary',
    'warning',
    'error',
    'success',
    'info',
    'accent-01',
    'accent-02',
    'accent-03',
    'accent-04',
    'accent-05',
    'accent-06',
    'basics-icon',
    'basics-text-secondary',
    'signal-error',
    'signal-success',
  ]
  return predefinedColors.includes(props.color as AppIconColor)
    ? `text-${props.color}`
    : props.color
})
</script>

<template>
  <Icon
    :name="name"
    :icon="name"
    :class="[iconSize, iconColor]"
    :aria-label="attrs?.['aria-label']"
  />
</template>
